import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import FormatterCommon from './formatter-common';

    

    function HistoricalGraphFormatter(params, observableOptions, dataSources, panelId) {
        var self = this;
        self.panelId = panelId;
        self.observableOptions = observableOptions;
        self.dataSources = dataSources;
        self.sourcetype = params && params.type ? params.type : "";
        self.datapresorted = params && params.datapresorted ? params.datapresorted : false;
        self.dataprepaged = params && params.dataprepaged ? params.dataprepaged : false;
        self.observableParams = dataSources[0].observableParams;
        self.observableFormattedData = ko.observable({});
        self.subscriptions = [];

        // TODO: This should come from metadata
        // There is a parcentageFlag property in the metadata that is associated with the metrics
        // but they're all set to 0 (not percentage). We should remove this and leverage the
        // metadata flag once it is working.
        self.isPercentage = !!params.isPercentage;
    }

    function ComposeTrendData(metric, group, sourcelist, options, maxGroups, isPercentage) {
        var formatterCommon = FormatterCommon;

        if (_.isEmpty(sourcelist)) {
            return {
                datasets: [],
                xaxislabels: []
            };
        }

        var groupvalues = [];
        if (!group) {
            groupvalues = [metric.columnDescription];
        }
        else {
            groupvalues = $.map(sourcelist,
                function (dataitem) {
                    return dataitem[group.columnName];
                });
            groupvalues = formatterCommon.sortUnique(groupvalues, true);
        }

        var times = $.map(sourcelist,
            function (dataitem) {
                return dataitem.periodStartDate ? dataitem.periodStartDate : dataitem.reporttime;
            });
        times = formatterCommon.sortUnique(times, false);

        var datasets = [];
        var groupSums = [];

        _.each(groupvalues, function(groupval, timeind) {
            var dataset = { name: groupval ? groupval : 'unknown', data: [] };
            var groupSum = { group: dataset.name, sum: 0, max: -1, maxtime: null, maxInd: 0 };

            times.forEach(function (timeval) {
                var dataitem = $.grep(sourcelist, function (srcitem) {
                    if (group) {
                        var rawval = srcitem[group.columnName];
                        var lowercase = (typeof (rawval) === 'string') ? rawval.toLowerCase() : rawval;

                        return (lowercase === groupval) &&
                            ((srcitem.periodStartDate === timeval) || (srcitem.reporttime === timeval));
                    }
                    return !timeval || srcitem.periodStartDate === timeval || srcitem.reporttime === timeval;
                });
                var aggregateFact = Math.round(_.get(dataitem, '[0].aggregateFact', 0) * (isPercentage ? 100 : 1));

                groupSum.sum += aggregateFact;

                if (aggregateFact > groupSum.max) {
                    groupSum.max = aggregateFact;
                    groupSum.maxtime = timeval;
                    groupSum.maxInd = timeind;
                }
                dataset.data.push([formatterCommon.truncatedISODateTimeToUnixEpoch(timeval), aggregateFact]);
            });
            groupSums.push(groupSum);
            datasets.push(dataset);
        });

        if (groupvalues.length > (maxGroups + 1)) {
            var groupSums2 = groupSums.sort(function (obj1, obj2) {
                return obj2.sum - obj1.sum;
            });
            var finalgroupnames = $.map(groupSums2.slice(0, maxGroups + 1), function (item) {
                return item.group;
            });
            var finaldatasets = $.grep(datasets, function (dsitem) {
                return $.inArray(dsitem.name, finalgroupnames) >= 0;
            });
            var datasetstoexclude = $.grep(datasets, function (dsitem) {
                return $.inArray(dsitem.name, finalgroupnames) < 0;
            });
            var lastdataset = $.grep(finaldatasets, function (dsitem) {
                return dsitem.name === finalgroupnames[maxGroups];
            })[0];

            lastdataset.name = "All Others";

            datasetstoexclude.forEach(function (dsitem) {
                dsitem.data.forEach(function(data, index) {
                    lastdataset.data[index][1] = data;
                });
            });
            datasets = finaldatasets;
        }
        return {
            datasets: datasets,
            groupSums: groupSums,
            selectedIndexes: $.map(groupSums, function (gs) { return gs.maxInd; }),
            ylabelSuffix: isPercentage ? "%" : ""
        };
    }

    function ComposeData(metadata, sourcelist, options, isPercentage) {
        var result = {};

        if (metadata && (!$.isEmptyObject(metadata)) && sourcelist && options && (!$.isEmptyObject(options))) {
            var metricKey = _.toLower(options.selectedMetricColumnNames[0]);
            var groupKey = _.toLower(options.selectedGroupColumnNames[0]);
            var metrics = $.grep(metadata.Table, function (metric) {
                return metric.columnKey === metricKey;
            });
            var groups = $.grep(metadata.GroupCols, function (group) {
                return group.columnKey === groupKey;
            });
            var metric = metrics[0];
            var group = groups[0];
            var maxGroups = options.maxGroups ? options.maxGroups : 5;

            if (options.type === "Trend") {
                result = ComposeTrendData(metric, group, sourcelist, options, maxGroups, isPercentage);
            }
        }
        return result;
    }

    HistoricalGraphFormatter.prototype.RefreshData = function () {
        var self = this;
        var metadata = self.dataRepository.flexQueryMetaData();

        if (!metadata) {
            return;
        }

        if (self.observableParams && !$.isEmptyObject(self.observableParams())) {
            self.sourceList = self.dataRepository
                .getDictionaryValue(self.dataRepository.FlexQueryResultDictionary, self.observableParams());
        }
        if (self.sourceList !== null) {
            self.observableFormattedData(ComposeData(
                metadata,
                self.sourceList,
                self.observableOptions(),
                self.isPercentage));
        } else {
            self.observableFormattedData({ metadata: metadata, rows: [] });
        }
    };

    HistoricalGraphFormatter.prototype.initialize = function (dataRepository, dataProvider) {
        var self = this;

        self.dataRepository = dataRepository;
        self.dataProvider = dataProvider;

        self.subscriptions.push(self.dataRepository.FlexQueryResultDictionary.subscribe(function() {
            if (self.dataRepository.lastPanelId === self.panelId) {
                self.RefreshData();
            }
        }));
        self.subscriptions.push(self.dataRepository.flexQueryMetaData.subscribe(function() {
            self.RefreshData();
        }));

        self.RefreshData();
    };

    HistoricalGraphFormatter.prototype.getObservableData = function () {
        var self = this;
        return self.observableFormattedData;
    };

    HistoricalGraphFormatter.prototype.dispose = function() {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default HistoricalGraphFormatter;
